import type { TransitionTable } from '../utils/StateMachine';

export const PlayerState = {
  Running: 'RUNNING',
  Jumping: 'JUMPING',
  DoubleJumping: 'DOUBLE_JUMPING',
  Falling: 'FALLING',
  Landing: 'LANDING',
  Sliding: 'SLIDING',
  Stumbling: 'STUMBLING',
  Hit: 'HIT',
  Dead: 'DEAD',
  /** On the seat of a vehicle (dozer set piece): steers with left/right, jumps off with jump. */
  Driving: 'DRIVING',
} as const;
export type PlayerState = (typeof PlayerState)[keyof typeof PlayerState];

/**
 * Allowed transitions. Every state can be left via HIT/DEAD except DEAD itself.
 * Animation mapping later: each state ↔ one (or a blend of) animation clip(s).
 * DRIVING is entered by a jump onto the vehicle – from the ground only by a protected runner (like its vault over a
 * wall) – and left with a jump off, a hit or death.
 */
export const PLAYER_STATE_TRANSITIONS: TransitionTable<PlayerState> = {
  RUNNING: ['JUMPING', 'FALLING', 'SLIDING', 'STUMBLING', 'HIT', 'DEAD', 'DRIVING'],
  JUMPING: ['DOUBLE_JUMPING', 'FALLING', 'LANDING', 'SLIDING', 'HIT', 'DEAD', 'DRIVING'],
  DOUBLE_JUMPING: ['FALLING', 'LANDING', 'SLIDING', 'HIT', 'DEAD', 'DRIVING'],
  FALLING: ['JUMPING', 'DOUBLE_JUMPING', 'LANDING', 'SLIDING', 'HIT', 'DEAD', 'DRIVING'],
  LANDING: ['RUNNING', 'JUMPING', 'SLIDING', 'STUMBLING', 'FALLING', 'HIT', 'DEAD', 'DRIVING'],
  SLIDING: ['RUNNING', 'JUMPING', 'FALLING', 'STUMBLING', 'HIT', 'DEAD', 'DRIVING'],
  STUMBLING: ['RUNNING', 'JUMPING', 'SLIDING', 'FALLING', 'HIT', 'DEAD', 'DRIVING'],
  HIT: ['RUNNING', 'DEAD'],
  DEAD: [],
  DRIVING: ['JUMPING', 'HIT', 'DEAD'],
};

export const AIRBORNE_STATES: readonly PlayerState[] = ['JUMPING', 'DOUBLE_JUMPING', 'FALLING'];
